module.exports = __webpack_public_path__ + "static/media/0.1f52778b.jpg";